import React, { useEffect, useState, useRef } from "react";
import { connect, useSelector } from "react-redux";
import * as Global from "../../../../styles/Global";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
} from "../../../../styles/Global";
import { setModal } from "../../../../features/modals/modalSlice";
import SlideUp from "../../../../components/modals/SlideUp";

const mapDispatch = { setModal };

const FindTournamentModalGroup = ({ setModal, data }) => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const sport = new URL(window.location.href).pathname.split("/")[2];
  const clubProfileModals = useSelector(
    (state) => state.modal.clubProfileModals
  );
  const globalModals = useSelector((state) => state.modal.globalModals);
  const playerModals = useSelector((state) => state.modal.playerModals);
  const playerModals2 = useSelector((state) => state.modal.playerModals2);
  const playerModals3 = useSelector((state) => state.modal.playerModals3);
  const playerModals4 = useSelector((state) => state.modal.playerModals4);
  const darkMode = useSelector((state) => state.global.darkMode);

  console.log("findtournamentmodalgroup playerModals4: ", playerModals4);

  return (
    <>
      {" "}
      <SlideUp
        displayModal={clubProfileModals.showModal}
        fullHeight
        maxHeight
        setDisplayModal={() =>
          setModal({
            clubProfileModals: { showModal: false, modalType: 31, data: {} },
          })
        }
        modalType={clubProfileModals.modalType}
        CloseModalAction={() =>
          setModal({
            clubProfileModals: { showModal: false, modalType: 31, data: {} },
          })
        }
        overlayZIndex={101}
        data={clubProfileModals.data}
        background={!darkMode && "#C0D4DE"}
      />
      <SlideUp
        displayModal={globalModals.showModal}
        setDisplayModal={() =>
          setModal({
            globalModals: { showModal: false, modalType: 31, data: {} },
          })
        }
        modalType={globalModals.modalType}
        CloseModalAction={() =>
          setModal({
            globalModals: { showModal: false, modalType: 31, data: {} },
          })
        }
        overlayZIndex={501}
        data={globalModals.data}
      />
      <SlideUp
        displayModal={playerModals.showModal}
        setDisplayModal={() =>
          setModal({
            playerModals: { showModal: false, modalType: 31, data: {} },
          })
        }
        modalType={playerModals.modalType}
        CloseModalAction={() =>
          setModal({
            playerModals: { showModal: false, modalType: 31, data: {} },
          })
        }
        overlayZIndex={502}
        data={playerModals.data}
      />
      <SlideUp
        displayModal={playerModals2.showModal}
        setDisplayModal={() =>
          setModal({
            playerModals2: { showModal: false, modalType: 32, data: {} },
          })
        }
        modalType={playerModals2.modalType}
        CloseModalAction={() =>
          setModal({
            playerModals2: { showModal: false, modalType: 32, data: {} },
          })
        }
        overlayZIndex={503}
        data={playerModals2.data}
      />
      <SlideUp
        displayModal={playerModals3.showModal}
        setDisplayModal={() =>
          setModal({
            playerModals3: { showModal: false, modalType: 32, data: {} },
          })
        }
        modalType={playerModals3.modalType}
        CloseModalAction={() =>
          setModal({
            playerModals3: { showModal: false, modalType: 32, data: {} },
          })
        }
        overlayZIndex={504}
        data={playerModals3.data}
      />
      <SlideUp
        displayModal={playerModals4.showModal}
        setDisplayModal={() =>
          setModal({
            playerModals4: { showModal: false, modalType: 32, data: {} },
          })
        }
        modalType={playerModals4.modalType}
        CloseModalAction={() =>
          setModal({
            playerModals4: { showModal: false, modalType: 32, data: {} },
          })
        }
        overlayZIndex={505}
        data={playerModals4.data}
      />
    </>
  );
};

export default connect(null, mapDispatch)(FindTournamentModalGroup);
